import React from 'react'
import InputMask from 'react-input-mask'
import PropTypes from 'prop-types'
import AsterTextField from 'asterX-UIkit/Inputs/AsterTextField'

const MaskedTextInput = ({
	mask,
	label,
	error = false,
	value,
	onChange,
	name,
	type = 'text',
	styles,
	helperText,
	disabled = false,
	variant = 'outlined',
	fullWidth
}) => {
	return (
		<InputMask
			mask={mask}
			name={name}
			maskChar={''}
			value={value}
			onChange={onChange}
			disabled={disabled}
		>
			{inputProps => (
				<AsterTextField
					{...inputProps}
					disabled={disabled}
					fullWidth={fullWidth}
					type={type}
					style={styles}
					error={Boolean(error)}
					helperText={helperText}
					label={label}
					variant={variant}
				/>
			)}
		</InputMask>
	)
}

export default MaskedTextInput

MaskedTextInput.propTypes = {
	mask: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	helperText: PropTypes.string,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	type: PropTypes.oneOf(['text', 'tel']),
	variant: PropTypes.oneOf(['outlined', 'contained', 'default']),
	fullWidth: PropTypes.bool
}
